<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <a id="button-vote" v-bind="attrs" v-on="on" v-if="type === 'link'">
          + Votar
        </a>

        <v-btn
          v-bind="attrs"
          v-on="on"
          v-else-if="type === 'button'"
          min-width="270"
          class="button-item"
          depressed
          dark
          color="#007E7A"
        >
          + Votar
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="card-title">
          <span class="headline">Confirme seu voto</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-card-subtitle>
                  <strong>OBS:</strong> Ao clicar em votar, você receberá um
                  e-mail para confirmar o seu voto. Para isso, abra o e-mail e
                  clique em "Confirmar voto".
                  <v-text-field
                    label="seuemail@dominio.com.br*"
                    required
                    v-model="email"
                    :rules="emailRules"
                  ></v-text-field> </v-card-subtitle
                ><br /><br /><br />

                <center v-show="hasClickedSendMail">
                  <strong v-show="!hiddenIconConfirmVote"
                    >Voto Registrado</strong
                  >
                  <v-fab-transition>
                    <v-btn
                      id="confirm-vote"
                      v-show="!hiddenIconConfirmVote"
                      color="success"
                      fab
                      dark
                      left
                    >
                      <v-icon>favorite_border</v-icon>
                    </v-btn>
                  </v-fab-transition>

                  <v-progress-circular
                    v-show="hiddenIconConfirmVote && hasClickedSendMail"
                    :size="60"
                    :width="7"
                    color="#20c09e"
                    indeterminate
                  ></v-progress-circular>
                </center>
              </v-col>
            </v-row>
            <v-alert type="error" v-show="voteError">
              {{ voteError }}
            </v-alert>
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn color="error" @click="dialog = false">Cancelar</v-btn>
          <v-btn dark color="success" @click="onVote">Votar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import { mapActions } from "vuex";

export default {
  name: "VoteForm",
  props: {
    type: undefined,
    emailRestriction: null,
    projectId: undefined,
    makeVoting: null,
  },
  created() {
    this.domain = this.$route.params.domain;
  },
  data: () => ({
    dialog: false,
    hiddenIconConfirmVote: true,
    hasClickedSendMail: false,
    email: "",
    emailRules: [
      (v) => !!v || "Seu e-mail é Obrigatório",
      (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
    ],
    voteError: undefined,
  }),
  methods: {
    ...mapActions(["makeVote"]),
    validateRestrictDomain(email) {
      this.voteError = undefined;
      const domain = this.email.split("@")[1];
      if (!domain) {
        this.voteError = "E-mail invalido, por favor informe um e-mail valido.";
        return false;
      }
      if (!this.emailRestriction || this.emailRestriction.length === 0) {
        return true; // Any email can vote
      }
      if (
        this.emailRestriction.filter((email) => email === domain).length === 0
      ) {
        this.voteError =
          "O e-mail que você está utilizando não é aceito para realizar esta votação.";
        return false;
      }
      return true;
    },
    async onVote() {
      if (!this.projectId) {
        this.voteError = "Selecione um projeto para votar.";
        throw Error("FromDialogVote VoteForm cannot vote without a project ID");
      }

      if (this.validateRestrictDomain(this.email)) {
        try {
          this.hasClickedSendMail = true;
          await this.$store.dispatch("makeVote", {
            email: this.email,
            projectId: this.projectId,
            domain: this.domain,
          });
        } catch (error) {
          this.voteError = `Não foi possivel continuar com o processo do seu voto. ${error.message}`;
          this.hiddenIconConfirmVote = true;
          this.hasClickedSendMail = false;
          return;
        }
        this.hiddenIconConfirmVote = false;
        this.hasClickedSendMail = false;
        const message =
          "Voto recebido! Confira sua caixa de e-mail e valide o seu voto.";
        this.email = null;
        this.hiddenIconConfirmVote = true;
        this.$emit("onSuccess", message);
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped>
.email-input {
  min-width: 300px;
}

.card-title {
  color: #e9e9e9;
  background: #20c09e;
}

#button-vote {
  background-color: #20c09e;
  color: #fff !important;

  height: 44px;
  padding: 10px 40px;
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  align-items: center;
  text-align: center;
  border-radius: 2px;
  box-sizing: border-box;
  user-select: none;
  outline: none;
  border: 0;
  white-space: nowrap;
  text-transform: uppercase;
  font-style: inherit;
  font-variant: inherit;
  font-family: inherit;
  text-decoration: none;
  overflow: hidden;
  margin: 32px 0;
}
</style>>



// WEBPACK FOOTER //
// src/components/form/voteonTheProject/VoteForm.vue